import { CalculateFieldNames } from 'utils/constants/fieldNames';
import { ICompanyInfo } from 'interfaces/store/companyInfo';
import { setChartField } from 'store/chartForms/chartForms.slice';
import { AppDispatch } from 'store';

export const populateChartFormsFromCompanyInfo = (
  companyInfo: ICompanyInfo,
  dispatch: AppDispatch
) => {
  if (!companyInfo.requiredInfo.status) return;

  const allFields = [
    {
      field: CalculateFieldNames.CURRENT_ARR,
      value: companyInfo.requiredInfo.currentARR
    },
    {
      field: CalculateFieldNames.ANNUAL_REVENUE,
      value: companyInfo.requiredInfo.revenue
    },
    {
      field: CalculateFieldNames.AVG_DEAL_SIZE,
      value: companyInfo.requiredInfo.avgDealSize
    },
    {
      field: CalculateFieldNames.YOY_ARR,
      value: companyInfo.requiredInfo.yoyARR
    },
    {
      field: CalculateFieldNames.FCF_MARGIN,
      value: companyInfo.requiredInfo.fcfMargin
    },
    {
      field: CalculateFieldNames.GROSS_MARGIN,
      value: companyInfo.requiredInfo.grossMargin
    },
    {
      field: CalculateFieldNames.TOTAL_HEADCOUNT,
      value: companyInfo.requiredInfo.totalHeadcount
    },
    {
      field: CalculateFieldNames.ARR_PER_FTE,
      value: companyInfo.requiredInfo.arrPerFTE
    },
    {
      field: CalculateFieldNames.RULE_OF_40,
      value: companyInfo.requiredInfo.ruleOf40
    },
    {
      field: CalculateFieldNames.NEW_LOGO_VELOCITY,
      value: companyInfo.growthAndRetention.newLogoVelocity
    },
    {
      field: CalculateFieldNames.NEW_LOGO_ARR_OF_GROSS_NEW,
      value: companyInfo.growthAndRetention.newLogoArrOfGrossNew
    },
    {
      field: CalculateFieldNames.EXPANSION_ARR_OF_GROSS_NEW,
      value: companyInfo.growthAndRetention.expansionArrOfGrossNew
    },
    {
      field: CalculateFieldNames.NEW_LOGO_ARR,
      value: companyInfo.growthAndRetention.newLogoArr
    },
    {
      field: CalculateFieldNames.EXPANSION_ARR,
      value: companyInfo.growthAndRetention.expansionArr
    },
    {
      field: CalculateFieldNames.QUICK_RATIO,
      value: companyInfo.growthAndRetention.quickRatio
    },
    {
      field: CalculateFieldNames.GROSS_DOLLAR_RETENTION,
      value: companyInfo.growthAndRetention.grossDollarRetention
    },
    {
      field: CalculateFieldNames.NET_DOLLAR_RETENTION,
      value: companyInfo.growthAndRetention.netDollarRetention
    },
    {
      field: CalculateFieldNames.CAC_PAYBACK_PERIOD,
      value: companyInfo.operationalEfficiency.cacPaybackPeriod
    },
    {
      field: CalculateFieldNames.NET_MAGIC_NUMBER,
      value: companyInfo.operationalEfficiency.netMagicNumber
    },
    {
      field: CalculateFieldNames.BURN_MULTIPLE,
      value: companyInfo.operationalEfficiency.burnMultiple
    },
    {
      field: CalculateFieldNames.RD_ABSOLUTE_OPEX,
      value: companyInfo.operationalEfficiency.rD
    },
    {
      field: CalculateFieldNames.GA_ABSOLUTE_OPEX,
      value: companyInfo.operationalEfficiency.gA
    },
    {
      field: CalculateFieldNames.SM_ABSOLUTE_OPEX,
      value: companyInfo.operationalEfficiency.sM
    },
    {
      field: CalculateFieldNames.TOTAL_OPEX,
      value: companyInfo.operationalEfficiency.totalOpex
    },
    {
      field: CalculateFieldNames.RD_PERCENT_OPEX,
      value: companyInfo.operationalEfficiency.rdPercent
    },
    {
      field: CalculateFieldNames.GA_PERCENT_OPEX,
      value: companyInfo.operationalEfficiency.gaPercent
    },
    {
      field: CalculateFieldNames.SM_PERCENT_OPEX,
      value: companyInfo.operationalEfficiency.smPercent
    },
    {
      field: CalculateFieldNames.OPEX_PER_FTE,
      value: companyInfo.headCount.opexPerFTE
    },
    {
      field: CalculateFieldNames.GA_HEADCOUNT,
      value: companyInfo.headCount.gAHead
    },
    {
      field: CalculateFieldNames.SM_HEADCOUNT,
      value: companyInfo.headCount.sMHead
    },
    {
      field: CalculateFieldNames.RD_HEADCOUNT,
      value: companyInfo.headCount.rDHead
    },
    {
      field: CalculateFieldNames.GA_HEADCOUNT_PERCENT,
      value: companyInfo.headCount.gAHeadPercent
    },
    {
      field: CalculateFieldNames.SM_HEADCOUNT_PERCENT,
      value: companyInfo.headCount.sMHeadPercent
    },
    {
      field: CalculateFieldNames.RD_HEADCOUNT_PERCENT,
      value: companyInfo.headCount.rDHeadPercent
    }
  ];

  allFields.forEach(({ field, value }) => {
    if (value !== null && !isNaN(value)) {
      dispatch(setChartField({ field, value: String(value) }));
    }
  });
};
